import { apiGetOneOrNull, apiPatch, apiPost } from '@/core/api/resources'
import type { WriteIdentity } from '@/core/api/http'
import type { SitzungAzavRead } from '../api/resources'

export type SitzungRow = {
  id: string
  datum: string
  beginn: string
  ue: number
  anwesenheit: string
  inhalt: string
  ort: string
  modulId: string
}

export type SitzungFields = {
  datum: string
  beginn: string
  ue: number
  anwesenheitId: string
  inhalt: string
  ort: string
  modulId: string
}

function normaliseBeginn(beginn: string): string {
  const match = /^(\d{2}:\d{2})/.exec(beginn)
  return match ? match[1] : beginn
}

function mapSitzungRow(row: SitzungAzavRead): SitzungRow {
  return {
    id: row.id,
    datum: row.datum,
    beginn: normaliseBeginn(row.beginn),
    ue: row.ue,
    anwesenheit: row.anwesenheit?.name ?? '',
    inhalt: row.inhalt,
    ort: row.ort,
    modulId: row.modul_id,
  }
}

export async function getSitzung(sitzungId: string): Promise<SitzungRow | null> {
  const row = await apiGetOneOrNull('/azav/sitzung/{id}', { id: sitzungId }, {
    include: ['anwesenheit'],
  })
  return row ? mapSitzungRow(row) : null
}

export async function insertSitzung(
  row: SitzungFields & { dokumentId: string },
  identity?: WriteIdentity,
): Promise<string> {
  const created = await apiPost('/azav/sitzung', {
    dokument_id: row.dokumentId,
    datum: row.datum,
    beginn: row.beginn,
    ue: row.ue,
    anwesenheit_id: row.anwesenheitId,
    inhalt: row.inhalt,
    ort: row.ort,
    modul_id: row.modulId,
  }, identity)
  return created.id
}

export async function updateSitzung(sitzungId: string, fields: SitzungFields, identity?: WriteIdentity): Promise<void> {
  await apiPatch('/azav/sitzung/{id}', { id: sitzungId }, {
    datum: fields.datum,
    beginn: fields.beginn,
    ue: fields.ue,
    anwesenheit_id: fields.anwesenheitId,
    inhalt: fields.inhalt,
    ort: fields.ort,
    modul_id: fields.modulId,
  }, identity)
}
